export default __webpack_public_path__ + "a8f724cb3ca376b91fda89e8a7885aa5.svg";